/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CheckLinkingStatusRequest} from '@cash-web/protos/squareup/cash/staff/api/v1beta1/staff_linking_messages.pb'
import {CheckLinkingStatusResponse} from '@cash-web/protos/squareup/cash/staff/api/v1beta1/staff_linking_messages.pb'


export const checkLinkingStatus = (request: CheckLinkingStatusRequest, options?: CashRequestOptions) => post<CheckLinkingStatusRequest, CheckLinkingStatusResponse>("/cash-app/staff/linking/check-linking-status", request, {...options, rejectOnError: true })